import request from "lib/helpers/requestApi";

export const updateDSP = request({
    method: 'upload.sendDspRequest',
  });

export const sendToGrid = request({
    method: 'upload.sendGridRequest',
  });

/** Запуск крона на деве для задач по массовому созданию крео */
export const sendMassCreativeAddTaskAPI = request({
  method: 'upload.sendMassCreativeAddTask',
});